import ServiceCRUD from '../../../services/ServiceCRUDSCALE';

class DayOffService extends ServiceCRUD {
  constructor() {
    super('/api/days-off-configurations');
  }
}

export default new DayOffService();
